import React from 'react';
import CarouselCustom from '../../../components/carousel/CarouselCustom';
import { IUser } from '../../../models/User.Model';
import GerUsuariosCarouselTabsUsuarios from './GerUsuariosCarouselTabsUsuarios';
import GerUsuariosCarouselTabsDepartamentos from './GerUsuariosCarouselTabsDepartamentos';
import GerUsuariosCarouselTabsHistAtividades from './GerUsuariosCarouselTabsHistAtividades';
import GerUsuariosCarouselTabsCentralAjuda from './GerUsuariosCarouselTabsCentralAjuda';
import GerUsuariosCarouselTabsMercados from './GerUsuariosCarouselTabsMercados';
import { useAuthorization } from "../../../contexts/AuthorizationContext";
import GerUsuariosCarouselTabsVolumetria from './GerUsuariosCarouselTabsVolumetria';


export default function GerUsuariosCarouselTabs(props: { id_user: number, usuario?: IUser, query: string, onChange: () => void }) {
    const [activeTab, setActiveTab] = React.useState(props.query ? 3 : 0);
    const { getConfig } = useAuthorization();


    const itens = props?.usuario?.id_permissao != 4 ? [
        { index: 0, hide: false, label: "Usuários", component: <GerUsuariosCarouselTabsUsuarios key={0} index={0} activeTab={activeTab} id_user={props.id_user} onChange={props.onChange} /> },
        { index: 1, hide: false, label: "Unidades de negócio", component: <GerUsuariosCarouselTabsDepartamentos key={1} index={1} activeTab={activeTab} id_user={props.id_user} /> },
        { index: 2, hide: false, label: "Histórico de Atividades", component: <GerUsuariosCarouselTabsHistAtividades key={2} index={2} activeTab={activeTab} id_user={props.id_user} /> },
        { index: 3, hide: false, label: "Central de Ajuda", component: <GerUsuariosCarouselTabsCentralAjuda key={3} index={3} activeTab={activeTab} id_user={props.id_user} /> },
        { index: 4, hide: !getConfig().habMercados, label: "Mercados", component: <GerUsuariosCarouselTabsMercados key={4} index={4} activeTab={activeTab} id_user={props.id_user} /> },
        { index: 5, hide: false, label: "Volumetria", component: <GerUsuariosCarouselTabsVolumetria key={5} index={5} activeTab={activeTab} id_user={props.id_user} /> },
    ]
        :
        [
            { index: 0, hide: false, label: "Central de Ajuda", component: <GerUsuariosCarouselTabsCentralAjuda key={0} index={0} activeTab={activeTab} id_user={props.id_user} id_permissao={props?.usuario?.id_permissao} /> },
        ]

    return (
        <CarouselCustom itens={itens} activeTab={activeTab} onChange={setActiveTab} />
    );
}